export default __webpack_public_path__ + "legacy/static/media/apple-logo-white.b875e0b1.png";